import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { PropsWithChildren, ReactNode } from 'react';

import { cn } from '@/utils/cn';

type DrawerProps = PropsWithChildren<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  footer?: ReactNode;
  width?: 'narrow' | 'default' | 'wide';
}>;

export function Drawer({
  open,
  onOpenChange,
  title,
  description,
  footer,
  width = 'default',
  children,
}: DrawerProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="drawer-overlay" />
        <Dialog.Content className={cn('drawer-panel', `drawer-panel--${width}`)}>
          <header className="drawer-panel__header">
            <div>
              <Dialog.Title className="drawer-panel__title">{title}</Dialog.Title>
              {description ? (
                <Dialog.Description className="drawer-panel__description">
                  {description}
                </Dialog.Description>
              ) : null}
            </div>
            <Dialog.Close asChild>
              <button type="button" className="icon-button drawer-panel__close-button" aria-label="Close drawer">
                <X size={18} />
              </button>
            </Dialog.Close>
          </header>
          <div className="drawer-panel__body">{children}</div>
          {footer ? <footer className="drawer-panel__footer">{footer}</footer> : null}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
